import BaseService from "@client.services/baseService";

export default class UserNotificationSettingService extends BaseService {
  constructor() {
    super("userNotificationSetting", true);
  }

  async getAll() {
    return super.api("");
  }

  async update(setting) {
    return super.put(`${setting.id}`, setting);
  }
}
